import { IconButton } from "@chakra-ui/react"
import { BlockType } from "@pathwright/blocks-engine"
import Pathicon from "@pathwright/ux/src/components/pathicon/Pathicon"
import { useState } from "react"
import { getBlockLinkUrl } from "../blocksLinks/utils"

type CopyBlockLinkProps = {
  block: BlockType
  onCopy?: () => void
}

const CopyBlockLink = ({ onCopy, block }: CopyBlockLinkProps) => {
  const [linkCopied, setLinkCopied] = useState(false)

  return (
    <IconButton
      aria-label="Link to this block"
      children={<Pathicon icon={linkCopied ? "check" : "link"} />}
      cursor="pointer"
      color="#666"
      onClick={() => {
        const url = getBlockLinkUrl(block.id)
        navigator.clipboard.writeText(url)

        setLinkCopied(true)
        setTimeout(() => setLinkCopied(false), 2000)

        if (onCopy) {
          onCopy()
        }
      }}
    />
  )
}

export default CopyBlockLink
